import IUser from "@/interfaces/user.interface";
import { UsersMessages } from "@/messages/users/user.messages";
import { FilterType, IFilter } from "@/types/filter.types";

export const USERS_TABLE_COLUMNS = (messages: UsersMessages) => {
  return [
    messages.nameColumn,
    messages.emailColumn,
    messages.phone1Column,
    messages.statusColumn,
    messages.optionsColumn,
  ];
};

export const initialFilterValues: IFilter<IUser>[] = [
  {
    property: "email",
    value: "",
    filterType: FilterType.Contains,
  },
];
